<template>
  <div class="chat-new">
    <div class="header">
      <label>To:</label>
      <div class="btn-item-added" v-for="(member, index) in members">
        {{ member.firstname + ' ' + member.surname }}
        <a class="remove" v-on:click="remove(index)"></a>
      </div>
      <div class="input-holder">
        <input v-model="keywords" type="text" autofocus="true">
        <ul :class="{ 'input-options': true, 'active': results.length }">
          <li v-for="user in results" class="input-option" v-on:click="add(user)" v-if="user['.key'] !== $root.user.uid">
            <div class="image-circle">
              <img :src="user.profileimg">
            </div>
            <span>{{ user.firstname + ' ' + user.surname }}</span>
          </li>
        </ul>
      </div>
    </div>
    <input type="text" class="message" v-model="message" placeholder="Type a message..." v-on:keydown.enter.prevent="send">
  </div>
</template>

<script>
import { db } from '@/firebase'
import router from '@/router'

export default {
  name: 'New',
  data () {
    return {
      message: '',
      members: [],
      keywords: '',
      results: [],
      chatID: null,
      oldChatMembers: null
    }
  },
  watch: {
    'keywords': function (current, previous) {
      if (current.length > 1) {
        current.toLowerCase()
        this.$bindAsArray('results', db.ref('users').orderByChild('searchterm').startAt(current).endAt(current + '\uf8ff'))
      } else {
        this.results = []
      }
    }
  },
  methods: {
    add (user) {
      if (user['.key'] !== this.$root.user.uid) {
        this.members.push(user)
        this.keywords = ''
      }
    },
    remove (index) {
      this.members.splice(index, 1)
    },
    send () {
      if (this.members.length === 0) {
        alert('Please add members to this chat.')
      } else if (this.message === '') {
        alert('Please type a message.')
      } else {
        var oldChatID = null
        if (this.members.length === 1) {
          console.log(this.$parent.chats)
          for (var chatsIndex in this.$parent.chats) {
            console.log(chatsIndex + ': ' + this.$parent.chats[chatsIndex]['.key'])
            this.$bindAsArray('oldChatMembers', db.ref('chats-members/' + this.$parent.chats[chatsIndex]['.key']))
            if (this.oldChatMembers.length === 2) {
              console.log('Two members chat')
              for (var chatMembersIndex in this.oldChatMembers) {
                console.log(chatMembersIndex)
                if (this.oldChatMembers[chatMembersIndex]['.key'] === this.members[0]['.key']) {
                  console.log('Same chat member found!')
                  oldChatID = this.$parent.chats[chatsIndex]['.key']
                  console.log('Push to: ' + oldChatID)
                  break
                }
              }
            }
            if (oldChatID) {
              break
            }
          }
        }
        // get chat id.
        if (oldChatID) {
          this.chatID = oldChatID
        } else {
          this.chatID = db.ref('chats').push().key
        }
        var updates = {}
        var timestamp = Date.now()
        // unreads.
        var unreads = {}
        for (var index in this.members) {
          unreads[this.members[index]['.key']] = 1
        }
        unreads[this.$root.user.uid] = 0
        // add chat.
        updates['/chats/' + this.chatID] = {
          lastMessage: this.$root.profile.firstname + ': ' + this.message,
          lastUpdated: timestamp,
          unreads: unreads
        }
        // add chat members
        if (!oldChatID) {
          updates['/chats-members/' + this.chatID] = {}
          for (index in this.members) {
            updates['/chats-members/' + this.chatID][this.members[index]['.key']] = true
          }
          updates['/chats-members/' + this.chatID][this.$root.user.uid] = true
          // add chat to members.
          for (index in this.members) {
            updates['/users-chats/' + this.members[index]['.key'] + '/' + this.chatID] = {
              createdAt: 0 - timestamp,
              showAfter: timestamp
            }
          }
          updates['/users-chats/' + this.$root.user.uid + '/' + this.chatID] = {
            createdAt: 0 - timestamp,
            showAfter: timestamp
          }
          updates['/chats-messages/' + this.chatID] = [{
            content: this.message,
            user: this.$root.user.uid,
            createdAt: timestamp
          }]
        } else {
          updates['/chats-messages/' + this.chatID + '/-new'] = {
            content: this.message,
            user: this.$root.user.uid,
            createdAt: timestamp
          }
        }
        db.ref().update(updates)
        this.message = ''
        router.push('/chats/' + this.chatID)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// New.vue?560ca574